// extracted by mini-css-extract-plugin
export default {"register":"Signup_register__N5Ch+","registerform":"Signup_registerform__sVFad"};